import React from 'react';
import './About.css';

function AboutSubsection({ title, items, isNumbered = false }) {
  const ListTag = isNumbered ? 'ol' : 'ul';
  const listClassName = isNumbered 
    ? 'about-list about-numbered-list' 
    : 'about-list';

  return (
    <div className="about-subsection">
      <h3>{title}</h3>
      <ListTag className={listClassName}>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ListTag>
    </div>
  );
}

export default AboutSubsection;

